"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeMapping = exports.iconList = exports.iconMapping = void 0;
var React = require("react");
var AmbulanceServices_1 = require("./AmbulanceServices");
var Ambulance_1 = require("./Ambulance");
var AppChevronDown_1 = require("./AppChevronDown");
var AppChevronLeft_1 = require("./AppChevronLeft");
var AppChevronRight_1 = require("./AppChevronRight");
var AppChevronUp_1 = require("./AppChevronUp");
var ArrowDownLong_1 = require("./ArrowDownLong");
var ArrowDown_1 = require("./ArrowDown");
var ArrowLeftLong_1 = require("./ArrowLeftLong");
var ArrowRightLong_1 = require("./ArrowRightLong");
var ArrowRight_1 = require("./ArrowRight");
var ArrowUp_1 = require("./ArrowUp");
var BandageCasts_1 = require("./BandageCasts");
var Bell_1 = require("./Bell");
var CalculatorSimple_1 = require("./CalculatorSimple");
var Calculator_1 = require("./Calculator");
var Calendar_1 = require("./Calendar");
var ChangeCover_1 = require("./ChangeCover");
var ChevronDownLight_1 = require("./ChevronDownLight");
var ChevronDown_1 = require("./ChevronDown");
var ChevronLeft_1 = require("./ChevronLeft");
var ChevronRightLight_1 = require("./ChevronRightLight");
var ChevronRight_1 = require("./ChevronRight");
var ChevronUp_1 = require("./ChevronUp");
var Claim_1 = require("./Claim");
var Claims_1 = require("./Claims");
var Copy_1 = require("./Copy");
var Couple_1 = require("./Couple");
var CreditCard_1 = require("./CreditCard");
var CrossCircleLight_1 = require("./CrossCircleLight");
var CrossCircle_1 = require("./CrossCircle");
var CrossLight_1 = require("./CrossLight");
var Cross_1 = require("./Cross");
var Customer_1 = require("./Customer");
var Delete_1 = require("./Delete");
var DeviceDesktop_1 = require("./DeviceDesktop");
var DirectDebit_1 = require("./DirectDebit");
var Document_1 = require("./Document");
var DollarCircle_1 = require("./DollarCircle");
var DollarSign_1 = require("./DollarSign");
var Envelope_1 = require("./Envelope");
var ErrorIcon_1 = require("./ErrorIcon");
var ExclamationCircle_1 = require("./ExclamationCircle");
var ExternalLinkLight_1 = require("./ExternalLinkLight");
var FacebookCircle_1 = require("./FacebookCircle");
var FilePdf_1 = require("./FilePdf");
var FileTextLight_1 = require("./FileTextLight");
var File_1 = require("./File");
var FindProvider_1 = require("./FindProvider");
var Hamburger_1 = require("./Hamburger");
var Heart_1 = require("./Heart");
var HelpAndSupport_1 = require("./HelpAndSupport");
var History_1 = require("./History");
var Home_1 = require("./Home");
var Hospital_1 = require("./Hospital");
var InfoCircle_1 = require("./InfoCircle");
var Instagram_1 = require("./Instagram");
var List_1 = require("./List");
var Lock_1 = require("./Lock");
var Logout_1 = require("./Logout");
var LoyaltyBonus_1 = require("./LoyaltyBonus");
var MapMarker_1 = require("./MapMarker");
var Mastercard_1 = require("./Mastercard");
var MedicalPlusSign_1 = require("./MedicalPlusSign");
var MemberDiscount_1 = require("./MemberDiscount");
var MinusCircle_1 = require("./MinusCircle");
var Minus_1 = require("./Minus");
var NewCard_1 = require("./NewCard");
var OfferTag_1 = require("./OfferTag");
var PartialCircle_1 = require("./PartialCircle");
var PencilBox_1 = require("./PencilBox");
var PencilLight_1 = require("./PencilLight");
var Pencil_1 = require("./Pencil");
var Percent_1 = require("./Percent");
var PhoneCircle_1 = require("./PhoneCircle");
var Phone_1 = require("./Phone");
var PlusCircle_1 = require("./PlusCircle");
var Plus_1 = require("./Plus");
var QuestionCircle_1 = require("./QuestionCircle");
var Receipt_1 = require("./Receipt");
var Refresh_1 = require("./Refresh");
var RestrictedCircle_1 = require("./RestrictedCircle");
var Search_1 = require("./Search");
var Share_1 = require("./Share");
var Shield_1 = require("./Shield");
var SimpleBitTick_1 = require("./SimpleBitTick");
var Single_1 = require("./Single");
var SpeechBubble_1 = require("./SpeechBubble");
var Stethoscope_1 = require("./Stethoscope");
var SubMenu_1 = require("./SubMenu");
var TickCircleLight_1 = require("./TickCircleLight");
var TickCircle_1 = require("./TickCircle");
var TickLight_1 = require("./TickLight");
var Tick_1 = require("./Tick");
var Time_1 = require("./Time");
var Tooth_1 = require("./Tooth");
var TwitterCircle_1 = require("./TwitterCircle");
var Umbrella1500K_1 = require("./Umbrella1500K");
var Umbrella250K_1 = require("./Umbrella250K");
var Umbrella_1 = require("./Umbrella");
var Upload_1 = require("./Upload");
var User_1 = require("./User");
var Visa_1 = require("./Visa");
var Warn_1 = require("./Warn");
var Youtube_1 = require("./Youtube");
exports.iconMapping = {
    "ambulance-services": AmbulanceServices_1.default,
    ambulance: Ambulance_1.default,
    "app-chevron-down": AppChevronDown_1.default,
    "app-chevron-left": AppChevronLeft_1.default,
    "app-chevron-right": AppChevronRight_1.default,
    "app-chevron-up": AppChevronUp_1.default,
    "arrow-down-long": ArrowDownLong_1.default,
    "arrow-down": ArrowDown_1.default,
    "arrow-left-long": ArrowLeftLong_1.default,
    "arrow-right-long": ArrowRightLong_1.default,
    "arrow-right": ArrowRight_1.default,
    "arrow-up": ArrowUp_1.default,
    "bandage-casts": BandageCasts_1.default,
    bell: Bell_1.default,
    "calculator-simple": CalculatorSimple_1.default,
    calculator: Calculator_1.default,
    calendar: Calendar_1.default,
    "change-cover": ChangeCover_1.default,
    "chevron-down-light": ChevronDownLight_1.default,
    "chevron-down": ChevronDown_1.default,
    "chevron-left": ChevronLeft_1.default,
    "chevron-right-light": ChevronRightLight_1.default,
    "chevron-right": ChevronRight_1.default,
    "chevron-up": ChevronUp_1.default,
    claim: Claim_1.default,
    claims: Claims_1.default,
    copy: Copy_1.default,
    couple: Couple_1.default,
    "credit-card": CreditCard_1.default,
    "cross-circle-light": CrossCircleLight_1.default,
    "cross-circle": CrossCircle_1.default,
    "cross-light": CrossLight_1.default,
    cross: Cross_1.default,
    customer: Customer_1.default,
    delete: Delete_1.default,
    "device-desktop": DeviceDesktop_1.default,
    "direct-debit": DirectDebit_1.default,
    document: Document_1.default,
    "dollar-circle": DollarCircle_1.default,
    "dollar-sign": DollarSign_1.default,
    envelope: Envelope_1.default,
    "error-icon": ErrorIcon_1.default,
    "exclamation-circle": ExclamationCircle_1.default,
    "external-link-light": ExternalLinkLight_1.default,
    "facebook-circle": FacebookCircle_1.default,
    "file-pdf": FilePdf_1.default,
    "file-text-light": FileTextLight_1.default,
    file: File_1.default,
    "find-provider": FindProvider_1.default,
    hamburger: Hamburger_1.default,
    heart: Heart_1.default,
    "help-and-support": HelpAndSupport_1.default,
    history: History_1.default,
    home: Home_1.default,
    hospital: Hospital_1.default,
    "info-circle": InfoCircle_1.default,
    instagram: Instagram_1.default,
    list: List_1.default,
    lock: Lock_1.default,
    logout: Logout_1.default,
    "loyalty-bonus": LoyaltyBonus_1.default,
    "map-marker": MapMarker_1.default,
    mastercard: Mastercard_1.default,
    "medical-plus-sign": MedicalPlusSign_1.default,
    "member-discount": MemberDiscount_1.default,
    "minus-circle": MinusCircle_1.default,
    minus: Minus_1.default,
    "new-card": NewCard_1.default,
    "offer-tag": OfferTag_1.default,
    "partial-circle": PartialCircle_1.default,
    "pencil-box": PencilBox_1.default,
    "pencil-light": PencilLight_1.default,
    pencil: Pencil_1.default,
    percent: Percent_1.default,
    "phone-circle": PhoneCircle_1.default,
    phone: Phone_1.default,
    "plus-circle": PlusCircle_1.default,
    plus: Plus_1.default,
    "question-circle": QuestionCircle_1.default,
    receipt: Receipt_1.default,
    refresh: Refresh_1.default,
    "restricted-circle": RestrictedCircle_1.default,
    search: Search_1.default,
    share: Share_1.default,
    shield: Shield_1.default,
    "simple-bit-tick": SimpleBitTick_1.default,
    single: Single_1.default,
    "speech-bubble": SpeechBubble_1.default,
    stethoscope: Stethoscope_1.default,
    "sub-menu": SubMenu_1.default,
    "tick-circle-light": TickCircleLight_1.default,
    "tick-circle": TickCircle_1.default,
    "tick-light": TickLight_1.default,
    tick: Tick_1.default,
    time: Time_1.default,
    tooth: Tooth_1.default,
    "twitter-circle": TwitterCircle_1.default,
    umbrella1500k: Umbrella1500K_1.default,
    umbrella250k: Umbrella250K_1.default,
    umbrella: Umbrella_1.default,
    upload: Upload_1.default,
    user: User_1.default,
    visa: Visa_1.default,
    warn: Warn_1.default,
    youtube: Youtube_1.default,
};
exports.iconList = [
    "ambulance-services",
    "ambulance",
    "app-chevron-down",
    "app-chevron-left",
    "app-chevron-right",
    "app-chevron-up",
    "arrow-down-long",
    "arrow-down",
    "arrow-left-long",
    "arrow-right-long",
    "arrow-right",
    "arrow-up",
    "bandage-casts",
    "bell",
    "calculator-simple",
    "calculator",
    "calendar",
    "change-cover",
    "chevron-down-light",
    "chevron-down",
    "chevron-left",
    "chevron-right-light",
    "chevron-right",
    "chevron-up",
    "claim",
    "claims",
    "copy",
    "couple",
    "credit-card",
    "cross-circle-light",
    "cross-circle",
    "cross-light",
    "cross",
    "customer",
    "delete",
    "device-desktop",
    "direct-debit",
    "document",
    "dollar-circle",
    "dollar-sign",
    "envelope",
    "error-icon",
    "exclamation-circle",
    "external-link-light",
    "facebook-circle",
    "file-pdf",
    "file-text-light",
    "file",
    "find-provider",
    "hamburger",
    "heart",
    "help-and-support",
    "history",
    "home",
    "hospital",
    "info-circle",
    "instagram",
    "list",
    "lock",
    "logout",
    "loyalty-bonus",
    "map-marker",
    "mastercard",
    "medical-plus-sign",
    "member-discount",
    "minus-circle",
    "minus",
    "new-card",
    "offer-tag",
    "partial-circle",
    "pencil-box",
    "pencil-light",
    "pencil",
    "percent",
    "phone-circle",
    "phone",
    "plus-circle",
    "plus",
    "question-circle",
    "receipt",
    "refresh",
    "restricted-circle",
    "search",
    "share",
    "shield",
    "simple-bit-tick",
    "single",
    "speech-bubble",
    "stethoscope",
    "sub-menu",
    "tick-circle-light",
    "tick-circle",
    "tick-light",
    "tick",
    "time",
    "tooth",
    "twitter-circle",
    "umbrella1500k",
    "umbrella250k",
    "umbrella",
    "upload",
    "user",
    "visa",
    "warn",
    "youtube",
];
exports.sizeMapping = {
    extraLarge: 48,
    extraSmall: 12,
    large: 32,
    medium: 24,
    small: 16,
};
var Icon = function (_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? "small" : _b, restOfProps = __rest(_a, ["name", "size"]);
    var IconToRender = exports.iconMapping[name];
    if (IconToRender === undefined) {
        throw new Error('No Icon matches provided "name" prop of "' + name + '".');
    }
    return React.createElement(IconToRender, __assign({ size: size }, restOfProps));
};
exports.default = Icon;
